// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11RQl","buttons":"Footer_buttons__o6J1p"};